import React from 'react';
import { ListingResource, useListingField } from '@brightmls/nextgen.lae.flc';
import UploadFile from './component/UploadFile';
import { CustomControlImplementation } from '../../../common/CustomControl';
import { FormField } from '../../FormField';
import { PropertyField } from '../../../../system/field';
import { OFFICE_EXCLUSIVE_KEY } from './types';
import { useFeatureFlags } from 'src/contexts/FeatureFlagsContext';
import { FeatureFlags } from 'src/flags';
import OfficeExclusiveUploadField from './component/OfficeExclusiveUploadField';

/**
 * OfficeExclusiveDocument component
 */
const OfficeExclusiveDocument: React.FC<CustomControlImplementation> = ({
  field,
  fieldMeta,
  fieldPresentation,
  fieldValue,
  onFieldValueChange,
  fieldFrame,
}) => {
  const { hasFeature } = useFeatureFlags();
  const isMediaV2 = hasFeature(FeatureFlags.NGW_MEDIA_V2);
  const officeExclusive = useListingField(
    ListingResource.Property,
    PropertyField.OFFICE_EXCLUSIVE_YN,
    false,
  );
  const isOfficeExclusive = officeExclusive.value === true;
  const oeDocField = useListingField(
    ListingResource.Property,
    OFFICE_EXCLUSIVE_KEY,
    '',
  );

  const isHighlighted = oeDocField.isHighlighted;

  if (!isOfficeExclusive) return null;

  return (
    <>
      <FormField
        field={{
          ...field,
          Key: OFFICE_EXCLUSIVE_KEY,
        }}
        fieldMeta={
          fieldMeta || {
            Name: 'Upload Office Exlusive Document',
            Key: OFFICE_EXCLUSIVE_KEY,
          }
        }
        fieldPresentation={{
          ...fieldPresentation,
          isHighlighted,
        }}
        fieldValue={fieldValue}
        onFieldValueChange={onFieldValueChange}
        {...{
          ...fieldFrame,
          isRequired: true,
        }}
        showLabel
      >
        {isMediaV2 ? (
          <OfficeExclusiveUploadField />
        ) : (
          <UploadFile
            // label="Upload Office Exlusive Document"
            description="This document will not be shared outside this listing"
          />
        )}
      </FormField>
    </>
  );
};

export default OfficeExclusiveDocument;

// TODO: Remove these once old media is deprecated
export { useFileUpload } from './hooks';
export {
  OFFICE_EXCLUSIVE_FILENAME,
  OFFICE_EXCLUSIVE_SHORT_DESC,
  OfficeExclusiveType,
} from './types';
